import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/pro-solid-svg-icons";
import classNames from "classnames/bind";
import { type ReactNode } from "react";
import styles from "./pdfIcon.module.scss";

const cn = classNames.bind(styles);

export const PdfIcon = ({ className }: { className?: string }): ReactNode => (
  <FontAwesomeIcon icon={faFilePdf} className={cn(styles.icon, className)} />
);
